import React from "react";
import Menu from "../atoms/Menu";
import MenuItem from "../atoms/MenuItem";
import MenuLink from "../atoms/MenuLink";
import styled from "styled-components";

const StyledMenu = styled(Menu)`
  flex-direction: column;
`;

const StyledMenuItem = styled(MenuItem)`
  width: 100%;
  line-height: 1.2rem;
`;

const DirectMenu = () => (
  <StyledMenu>
    <StyledMenuItem isFooterLink={true}>
      <MenuLink href="https://www.knhb.nl/spelregels-hockey" isFooterLink={true}>
        Spelregels hockey
      </MenuLink>
    </StyledMenuItem>
    <StyledMenuItem isFooterLink={true}>
      <MenuLink href="https://www.knhb.nl/kenniscentrum" isFooterLink={true}>
        Kenniscentrum
      </MenuLink>
    </StyledMenuItem>
    <StyledMenuItem isFooterLink={true}>
      <MenuLink href="https://www.knhb.nl/kenniscentrum/opleidingen" isFooterLink={true}>
        Opleidingen
      </MenuLink>
    </StyledMenuItem>
    <StyledMenuItem isFooterLink={true}>
      <MenuLink href="https://www.knhb.nl/over-knhb" isFooterLink={true}>
        Over KNHB
      </MenuLink>
    </StyledMenuItem>
    <StyledMenuItem isFooterLink={true}>
      <MenuLink href="https://www.knhb.nl/agenda" isFooterLink={true}>
        Agenda
      </MenuLink>
    </StyledMenuItem>
    <StyledMenuItem isFooterLink={true}>
      <MenuLink href="https://www.knhb.nl/clubs" isFooterLink={true}>
        Clubs
      </MenuLink>
    </StyledMenuItem>
    <StyledMenuItem isFooterLink={true}>
      <MenuLink href="https://www.knhb.nl/match-center" isFooterLink={true}>
        Match Center
      </MenuLink>
    </StyledMenuItem>
    <StyledMenuItem isFooterLink={true}>
      <MenuLink href="https://www.knhb.nl/kids" isFooterLink={true}>
        Kids
      </MenuLink>
    </StyledMenuItem>
  </StyledMenu>
);

export default DirectMenu;
